import { useQueries } from '@tanstack/react-query';
import { QUERY_KEYS } from '../Constants/queryKeys';

export type PublicHoliday = {
  date: string; // 'YYYY-MM-DD'
  localName: string; // Romanian name
  name: string; // English name
};

// Public API, so it is called with plain fetch: the app's auth token must not be sent there
const PUBLIC_HOLIDAYS_API = 'https://date.nager.at/api/v3/PublicHolidays';

const GetRomanianPublicHolidays = async (
  year: number
): Promise<Array<PublicHoliday>> => {
  const response = await fetch(`${PUBLIC_HOLIDAYS_API}/${year}/RO`);
  if (!response.ok) {
    throw new Error(`Failed to load public holidays for ${year}`);
  }
  return (await response.json()) as Array<PublicHoliday>;
};

// A study year spans two calendar years, so the holidays of both are loaded
export const useRomanianPublicHolidays = (years: Array<number>) => {
  return useQueries({
    queries: years.map((year) => ({
      queryKey: [...QUERY_KEYS.ROMANIAN_PUBLIC_HOLIDAYS, year],
      queryFn: () => GetRomanianPublicHolidays(year),
      // Public holidays of a year don't change
      staleTime: Infinity,
    })),
    combine: (results) => ({
      holidays: results.flatMap((result) => result.data ?? []),
      isLoading: results.some((result) => result.isLoading),
      isError: results.some((result) => result.isError),
    }),
  });
};
